module.exports = __webpack_public_path__ + "static/media/FifteenMinuteRule.fd7f1ed5.jpg";